/**
 * Enum mit den moeglichen Berechtigungen die ein Benutzer auf einer bestimmten page haben kann
 */
export enum TSBerechtigung {
    EDIT = <any> 'EDIT',
    READONLY = <any> 'READONLY',
    NO_ACCESS = <any> 'NO_ACCESS'
}

export function getTSBerechtigung(): Array<TSBerechtigung> {
    return [
        TSBerechtigung.EDIT,
        TSBerechtigung.READONLY,
        TSBerechtigung.NO_ACCESS
    ];
}




// WEBPACK FOOTER //
// ./src/app/models/enums/TSBerechtigung.ts